// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"131":"8168dd5c","628":"ffcfa759","793":"0a82c7a8"}[chunkId] + ".css";
};